/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { RouteToActionHandler } from '../action/RouteToActionHandler';
import { ChangedAfterDoubleCheckConditionEvaluation } from '../condition/ChangedAfterDoubleCheckConditionEvaluation';
import { SubmitOnTimeConditionEvaluator } from '../condition/SubmitOnTimeConditionEvaluator';
import { ClickSubmitOnTimeWithinRemainQuestionConditionEvaluator } from '../condition/ClickSubmitOnTimeWithinRemainQuestionConditionEvaluator';
import { IPolicyHandler } from './IPolicyHandler';
import { IConditionEvaluator } from '../condition/IConditionEvaluator';
import { IActionHandler } from '../action/IActionHandler';
import { RemainQuestionConditionEvaluator } from '../condition/RemainQuestionConditionEvaluator';
import { RemainTimeConditionEvaluator } from '../condition/RemainTimeConditionEvaluator';
import { ShowModalActionHandler } from '../action/ShowModalActionHandler';
import { SetValueActionHandler } from '../action/SetValueActionHandler';
import { SubmitTestAction } from '../action/SubmitTestAction';
import { AnswerAllQuestionsConditionEvaluator } from '../condition/AnswerAllQuestionsConditionEvaluator';
import { ClickSubmitWithinRemainTimeAndQuestionConditionEvaluator } from '../condition/ClickSubmitWithinRemainTimeAndQuestionConditionEvaluator';
import { ScoreConditionEvaluator } from '../condition/ScoreConditionEvaluator';
import { SubmitAfterWarningConditionEvaluator } from '../condition/SubmitAfterWarningConditionEvaluator';
import { DoubleCheckConditionEvaluation } from '../condition/DoubleCheckConditionEvaluation';
import { SubmitAnywayConditionEvaluator } from '../condition/SubmitAnywayConditionEvaluator';
import { SkillConditionEvaluator } from '../condition/SkillConditionEvaluation';
import { ReviewingConditionEvaluator } from '../condition/ReviewingConditionEvaluator';
import { ComparisonConditionEvaluator } from '../condition/ComparisonConditionEvaluator';
import { TestTypeConditionEvaluator } from '../condition/TestTypeConditionEvaluator';

export const useDefaultPolicy = () => {
  return React.useMemo(() => new DefaultPolicyHandler(), []);
};

export class DefaultPolicyHandler implements IPolicyHandler {
  conditionEvaluators: IConditionEvaluator[];

  actionHandlers: IActionHandler[];

  constructor() {
    this.conditionEvaluators = [
      new RemainQuestionConditionEvaluator(),
      new RemainTimeConditionEvaluator(),
      new AnswerAllQuestionsConditionEvaluator(),
      new ClickSubmitWithinRemainTimeAndQuestionConditionEvaluator(),
      new ScoreConditionEvaluator(),
      new SubmitAfterWarningConditionEvaluator(),
      new DoubleCheckConditionEvaluation(),
      new SubmitAnywayConditionEvaluator(),
      new SubmitOnTimeConditionEvaluator(),
      new ClickSubmitOnTimeWithinRemainQuestionConditionEvaluator(),
      new ChangedAfterDoubleCheckConditionEvaluation(),
      new SkillConditionEvaluator(),
      new ReviewingConditionEvaluator(),
      new ComparisonConditionEvaluator(),
      new TestTypeConditionEvaluator(),
    ];
    this.actionHandlers = [
      new ShowModalActionHandler(),
      new SetValueActionHandler(),
      new SubmitTestAction(),
      new RouteToActionHandler(),
    ];
  }

  async handlePolicy(policy: any, data: any): Promise<boolean> {
    const isHandlePolicy = this.canHandlePolicy(policy, data);
    if (isHandlePolicy) {
      await this.handleActions(policy.action, data);
    }
    return Promise.resolve(isHandlePolicy);
  }

  async handleActions(action, data) {
    return Promise.all(
      this.actionHandlers
        .filter((mainAction) => mainAction.canHandleAction(action))
        .map((actionHandler) =>
          actionHandler.handleAction(action, data, (subAction) =>
            this.handleActions(subAction, data)
          )
        )
    );
  }

  canHandlePolicy(policy: any, data: any): boolean {
    return policy.conditions.some((condition) =>
      this.conditionEvaluators
        .filter((evaluator) => evaluator.canHandleCondition(condition))
        .every((evaluator) => evaluator.isMatchCondition(condition, data))
    );
  }
}
